<template>
	<div>
		<Modal
			:show="showModal"
			@close="closeModal"
			body-classes="m-0 pt-0 pb-0"
			:hideFooter="true"
			footer-classes="pt-0"
			header-classes="pb-1"
			size="lg"
		>
			<template v-slot:header>
				<h5 class="modal-title" id="modalTitle">{{ headerTitle }}</h5>
			</template>

			<b-overlay :show="isLoading" rounded="sm">
				<div class="pt-2">
					<h5 style="flex: auto; text-align: center">
						Create a new user account. This user will automatically receive a password
						reset email.
					</h5>
					<h6 v-if="errorMessage" style="color: red; flex: auto; text-align: center">
						{{ errorMessage }}
					</h6>
				</div>

				<form class="pt-1 pb-1">
					<b-row>
						<b-col>
							<BaseInput
								label="First Name"
								id="title"
								placeholder="First Name"
								required
								type="text"
								v-model="userData.firstName"
							/>
						</b-col>
						<b-col>
							<BaseInput
								label="Last Name"
								id="title"
								placeholder="Last Name"
								required
								type="text"
								v-model="userData.lastName"
							/>
						</b-col>
					</b-row>
					<BaseInput
						label="Email"
						id="title"
						placeholder="Email"
						required
						type="text"
						v-model="userData.email"
					/>

					<BaseInput
						label="Password (auto-generated)"
						id="title"
						placeholder="Password"
						required
						type="password"
						disabled
						v-model="userData.password"
					/>
					<b-row class="mr-0 mt-3 mb-3">
						<div style="flex-grow: 1"></div>
						<BaseButton
							type="primary"
							:loading="isLoading"
							:shake="shake"
							@click="submit"
							>Add Member</BaseButton
						>
					</b-row>
				</form>
			</b-overlay>
		</Modal>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import BaseButton from '../../components/BaseButton.vue';
import BaseInput from '../../components/Inputs/BaseInput.vue';
import Modal from '../../components/Modals/Modal.vue';
import helpers from '../../helpers/helpers';
import AppUserManager from '../../models/AppUser/AppUserManager';

export default {
	components: { Modal, BaseInput, BaseButton },
	props: {
		headerTitle: {
			type: String,
			default: 'New Member Account',
		},
		showModal: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		showModal: {
			handler() {
				return this.resetModal();
			},
		},
	},
	data() {
		return {
			shake: false,
			isLoading: false,
			errorMessage: null,
			userData: {
				firstName: null,
				lastName: null,
				email: null,
				password: null,
			},
		};
	},
	methods: {
		...mapActions(['showNotification']),
		closeModal() {
			this.$emit('update:show', false);
			this.$emit('close');
		},
		resetModal() {
			this.userData = {
				firstName: null,
				lastName: null,
				email: null,
				password: this.getAutoGeneratedPwrd(),
			};
		},
		getAutoGeneratedPwrd() {
			var chars =
				'0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			var passwordLength = 8;
			var password = '';
			for (var i = 0; i <= passwordLength; i++) {
				var randomNumber = Math.floor(Math.random() * chars.length);
				password += chars.substring(randomNumber, randomNumber + 1);
			}
			return password;
		},
		submit() {
			if (
				this.$helpers.isBlank(this.userData.firstName) ||
				this.$helpers.isBlank(this.userData.lastName) ||
				this.$helpers.isBlank(this.userData.email) ||
				this.$helpers.isBlank(this.userData.password)
			) {
				this.errorMessage = 'Please complete all the necessary fields.';
				this.shake = true;
				return;
			} else {
				this.isLoading = true;
				AppUserManager.createNewUser(this.userData)
					.then((data) => {
						this.$emit('newUser', data);
						this.isLoading = false;
						this.closeModal();
					})
					.catch((errorMessage) => {
						this.isLoading = false;
						this.showNotification({
							type: 'danger',
							message: errorMessage,
						});
					});
			}
		},
	},
};
</script>
